import { Badge, cn } from "@simplicity/ui";
import type { RunStatus, TableRun } from "../../types";
import { STATUS_COLORS } from "../RunsTable.utils";

const MODE_BADGE_CLASS =
  "rounded-[3px] px-1.5 py-0.5 text-[0.6rem] font-semibold tracking-[0.03em]";

export function StatusBadge({ status }: { status: RunStatus }) {
  const { label, variant, pulse } = STATUS_COLORS[status];
  const title =
    status === "abandoned"
      ? "Continuation chain exceeded its maximum wall-clock duration and was terminated."
      : undefined;
  return (
    <Badge
      variant={variant}
      className={cn("text-[0.65rem] tracking-[0.03em]", pulse && "badge-pulse")}
      title={title}
    >
      {label}
    </Badge>
  );
}

export function ModeBadge({ mode }: { mode: string | null }) {
  if (!mode)
    return (
      <Badge variant="secondary" className={MODE_BADGE_CLASS}>
        –
      </Badge>
    );
  const isIncremental = mode === "incremental";
  return (
    <Badge variant={isIncremental ? "info" : "success"} className={MODE_BADGE_CLASS}>
      {isIncremental ? "incr" : "full"}
    </Badge>
  );
}

export function ConnectorModeSummary({ tableRuns }: { tableRuns: TableRun[] }) {
  const hasIncremental = tableRuns.some((r) => r.mode === "incremental");
  const hasFull = tableRuns.some((r) => r.mode === "full");

  if (!hasIncremental && !hasFull) {
    return (
      <Badge variant="secondary" className={MODE_BADGE_CLASS}>
        –
      </Badge>
    );
  }

  return (
    <span className="inline-flex gap-1.5">
      {hasIncremental && (
        <Badge variant="info" className={MODE_BADGE_CLASS} title="incremental">
          I
        </Badge>
      )}
      {hasFull && (
        <Badge variant="success" className={MODE_BADGE_CLASS} title="full">
          F
        </Badge>
      )}
    </span>
  );
}
